import React, {useEffect, useState} from "react"
import PropTypes from "prop-types"

export default function Dropdown(props){
	
	let initialValue = props.initialValue ? props.initialValue : ''
	
	const [selected, setSelected] = useState(initialValue)
	
	useEffect(() => { props.onChangeCallback(selected)}, [selected])
	
	const handleOnChange = (event) => {
		setSelected(event.target.value)
	}
	
	return(
		<select onChange={handleOnChange} value={selected}>
			{props.options.map((x, index) => (
				<option key={index} value={x.value}>{x.display}</option>
			))}
		</select>
	)
}

Dropdown.propTypes = {
	initialValue: PropTypes.string,
	options: PropTypes.arrayOf(PropTypes.object).isRequired,
	onChangeCallback: PropTypes.func.isRequired
}